import React from "react";
import Styles from "./Badge.scss";

interface BadgeProps {
    number: number;
    testId: string;
}
export const Badge: React.FC<BadgeProps> = ({ number, testId }) => {
    return (
        <span data-testid={testId}>
            <style jsx>{Styles}</style>
            {number}
        </span>
    );
};
